import React, { useEffect, useState } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import Navbar from "./Navbar";
import ApplyTabForm from "./ApplyTabForm";
import Registerform from "./Registerform";
// import Backupcode from "./Backupcode";

function Index(props) {
  return (
    <>
      <Switch>
        <>
          <Navbar />
          {/* <Route path="/test" exact component={Backupcode} /> */}
          <Route path="/" exact component={ApplyTabForm} />
        </>
      </Switch>
    </>
  );
}

const mapStateToProps = (state) => ({
  sectionClass: state.sidebarReducer.sectionClass,
});

export default connect(mapStateToProps)(Index);
